module.exports = __webpack_public_path__ + "static/Olympo-29-1b343491c3891f42bf05b5f245689683.jpg";